import React, { Fragment } from 'react'
import Input from 'components/Input'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function FormOne({ t }) {


  const fields = [
    [
      {
        name: 'title',
        label: t('promo.form.1.title.label'),
        placeholder: t('promo.form.1.title.placeholder'),
        required: true
      },
      {
        name: 'callback_url',
        label: t('promo.form.1.url.label'),
        placeholder: t('promo.form.1.url.placeholder'),
        required: true
      },
    ],
    {
      name: 'type',
      label: t('promo.form.1.type'),
      options: [
        {
          label: 'Flyer or photo',
          value: 'flyer',
          required: true
        },
        {
          label: 'Video',
          value: 'video',
          required: true
        }
      ]
    },
    {
      name: 'message',
      label: t('promo.form.1.message.label'),
      placeholder: t('promo.form.1.message.placeholder'),
      multiline: true,
      rows: 4,
      required: true
    },
    {
      name: 'description',
      label: t('promo.form.1.description.label'),
      placeholder: t('promo.form.1.description.placeholder'),
      multiline: true,
      rows: 4,
      required: true
    }
  ]
  React.useEffect(() => {

  },[])
  return (
    <div className="grid grid-cols-2 gap-5 mb-8">
      {
        fields.map((field, index) => {
          return (
            <Fragment key={`form-one-${index}`}>
              {
                field.length ? (
                  <>
                    {
                      field.map(singleField => {
                        return (
                          <Input 
                            name={singleField.name}
                            label={singleField.label}
                            placeholder={singleField.placeholder}
                            variant="filled"
                            key={singleField.name}
                            required={singleField.required}
                          />
                        )
                      })
                    }
                  </>
                ) : (
                  <div className="col-span-2">
                    <Input
                      name={field.name}
                      label={field.label}
                      placeholder={field.placeholder}
                      options={field?.options}
                      multiline={field?.multiline}
                      rows={field?.rows}
                      variant="filled"
                      required={field.required}
                    />
                  </div>
                )
              }
            </Fragment>
          )
        })
      }
    </div>
  )
})
